module.exports = __webpack_public_path__ + "static/media/serial_number_info.79963e7d.png";